<template>
<AppLayout>
  <div class="inventory">
    <section id="tender-categories" class="filter-search">
      <div class="container">
          <h6 class="fw-bold">Procurement Categories</h6>
          
          <div class="mt-1">
              
              <div class="row mt-2">
                  <div class="col-md-4">
                      <button class="btn btn-primary btn-small" @click="openAddModal">
                          <span>+ Add Procurement Category</span>
                      </button>
                  </div>
              </div>

              <div class="row mt-4">
                  <table class="table table-hover" id="tenderCategoriesTable">
                      <thead>
                          <tr>
                              <th>No.</th>
                              <th>Tender Category</th>
                              <th>Linked Departments</th>
                              <th>Supplier Count</th>
                              <th>Created By</th>
                              <th>Created At</th>
                              <th>Action</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(category, index) in tenderCategories" :key="category.id">
                              <td>{{ index + 1 }}</td>
                              <td>{{ category.name }}</td>
                              <td>
                                <span v-if="categoryDepartments(category).length === 0" class="text-muted small">All departments</span>
                                <span v-else class="small">{{ categoryDepartments(category).map(d => d.name).join(', ') }}</span>
                              </td>
                              <td>{{ category._count?.supplierTenderCategories || 0 }}</td>
                              <td>{{ category.user?.name || 'System' }}</td>
                              <td>{{ formatDate(category.createdAt) }}</td>
                              <td class="d-flex gap-1">
                                  <button class="btn btn-sm btn-secondary" @click="openEditModal(category)">Edit</button>
                                  <button class="btn btn-sm btn-danger" @click="deleteTenderCategory(category.id)">Delete</button>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
    </section>

    <!-- Add Category Modal -->
    <div v-if="addModal.show" class="modal-backdrop-custom" @click.self="closeAddModal">
      <div class="modal-box">
        <div class="modal-header-custom">
          <h6 class="mb-0 fw-bold">Add Procurement Category</h6>
          <button class="btn-close" @click="closeAddModal"></button>
        </div>
        <div class="modal-body-custom">
          <div class="mb-3">
            <label class="form-label fw-semibold">Category Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="addModal.name" placeholder="e.g., Office Supplies, IT Services" />
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Link to Departments</label>
            <p class="text-muted small mb-2">Leave all unchecked to make this category available to <strong>all departments</strong>.</p>
            <div v-if="loadingDepartments" class="text-muted small">Loading departments…</div>
            <div v-else class="dept-checklist">
              <div v-for="dept in allDepartments" :key="dept.id" class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="'add-dept-' + dept.id"
                  :value="dept.id"
                  v-model="addModal.selectedDepartmentIds"
                />
                <label class="form-check-label" :for="'add-dept-' + dept.id">{{ dept.name }}</label>
              </div>
              <div v-if="allDepartments.length === 0" class="text-muted small">No departments found.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer-custom">
          <button class="btn btn-secondary btn-sm" @click="closeAddModal">Cancel</button>
          <button class="btn btn-primary btn-sm" @click="saveNewCategory" :disabled="isPosting">
            <span v-if="isPosting">Creating…</span>
            <span v-else>Create Category</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Edit Category Modal -->
    <div v-if="editModal.show" class="modal-backdrop-custom" @click.self="closeEditModal">
      <div class="modal-box">
        <div class="modal-header-custom">
          <h6 class="mb-0 fw-bold">Edit Procurement Category</h6>
          <button class="btn-close" @click="closeEditModal"></button>
        </div>
        <div class="modal-body-custom">
          <div class="mb-3">
            <label class="form-label fw-semibold">Category Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="editModal.name" placeholder="Category name" />
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Link to Departments</label>
            <p class="text-muted small mb-2">Leave all unchecked to make this category available to <strong>all departments</strong>.</p>
            <div v-if="loadingDepartments" class="text-muted small">Loading departments…</div>
            <div v-else class="dept-checklist">
              <div v-for="dept in allDepartments" :key="dept.id" class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="'dept-' + dept.id"
                  :value="dept.id"
                  v-model="editModal.selectedDepartmentIds"
                />
                <label class="form-check-label" :for="'dept-' + dept.id">{{ dept.name }}</label>
              </div>
              <div v-if="allDepartments.length === 0" class="text-muted small">No departments found.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer-custom">
          <button class="btn btn-secondary btn-sm" @click="closeEditModal">Cancel</button>
          <button class="btn btn-primary btn-sm" @click="saveEdit" :disabled="isSavingEdit">
            <span v-if="isSavingEdit">Saving…</span>
            <span v-else>Save Changes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</AppLayout>
</template>

<script>
import Swal from 'sweetalert2'
import AppLayout from '../../components/AppLayout.vue';
import $ from 'jquery'
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

export default {
  name: 'AddTenderCategory',
  components: {
    AppLayout
  },
  data: () => ({
    token: JSON.parse(localStorage.getItem('access_token')),
    urlServer: process.env.VUE_APP_URL,
    tenderCategory: "",
    tenderCategories: [],
    isPosting: false,
    dataTable: null,
    // Departments
    allDepartments: [],
    loadingDepartments: false,
    // Add modal
    addModal: {
      show: false,
      name: '',
      selectedDepartmentIds: [],
    },
    // Edit modal
    editModal: {
      show: false,
      categoryId: null,
      name: '',
      selectedDepartmentIds: [],
    },
    isSavingEdit: false,
  }),
  async created() {
    await Promise.all([this.fetchTenderCategories(), this.fetchAllDepartments()])
  },
  beforeUnmount() {
    if (this.dataTable) {
      try { this.dataTable.destroy(); } catch(e) { console.warn(e); }
      this.dataTable = null;
    }
  },
  methods: {
    categoryDepartments(category) {
      if (!category.departmentAssignments) return []
      return category.departmentAssignments.map(a => a.department).filter(Boolean)
    },

    async fetchAllDepartments() {
      this.loadingDepartments = true
      try {
        const res = await fetch(this.urlServer + '/departments', {
          headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
        })
        const data = await res.json()
        this.allDepartments = Array.isArray(data) ? data : (data.data || [])
      } catch (err) {
        console.error('Failed to load departments', err)
      } finally {
        this.loadingDepartments = false
      }
    },

    openAddModal() {
      this.addModal.name = ''
      this.addModal.selectedDepartmentIds = []
      this.addModal.show = true
    },

    closeAddModal() {
      this.addModal.show = false
      this.addModal.name = ''
      this.addModal.selectedDepartmentIds = []
    },

    async saveNewCategory() {
      if (!this.addModal.name.trim()) {
        Swal.fire({ icon: 'warning', title: 'Required', text: 'Please enter a category name.' })
        return
      }
      this.isPosting = true
      try {
        // 1. Create the category
        const res = await fetch(this.urlServer + '/tender-category', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
          body: JSON.stringify({ name: this.addModal.name.trim() })
        })
        const data = await res.json()
        
        if (!data.status && !(data.data && data.data.id)) {
          Swal.fire({ icon: 'error', title: 'Failed to create', text: data.message || 'Error occurred' })
          return
        }

        const categoryId = data.data?.id || data.id
        
        // 2. Link departments if any are selected
        if (this.addModal.selectedDepartmentIds.length > 0) {
          const res2 = await fetch(`${this.urlServer}/tender-category/${categoryId}/departments`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
            body: JSON.stringify({ departmentIds: this.addModal.selectedDepartmentIds })
          })
          const data2 = await res2.json()
          if (!res2.ok || !data2.status) {
            console.warn('Warning: Category created but departments could not be linked', data2.message)
          }
        }

        await this.fetchTenderCategories()
        this.closeAddModal()
        Swal.fire({ 
          icon: 'success', 
          title: 'Success', 
          text: 'Procurement category created successfully.',
          timer: 1500, 
          showConfirmButton: false 
        })
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error', text: err.message })
      } finally {
        this.isPosting = false
      }
    },

    openEditModal(category) {
      this.editModal.categoryId = category.id
      this.editModal.name = category.name
      this.editModal.selectedDepartmentIds = this.categoryDepartments(category).map(d => d.id)
      this.editModal.show = true
    },

    closeEditModal() {
      this.editModal.show = false
      this.editModal.categoryId = null
      this.editModal.name = ''
      this.editModal.selectedDepartmentIds = []
    },

    async saveEdit() {
      if (!this.editModal.name.trim()) {
        Swal.fire({ icon: 'warning', title: 'Required', text: 'Please enter a category name.' })
        return
      }
      this.isSavingEdit = true
      try {
        const id = this.editModal.categoryId

        // 1. Rename if needed
        const original = this.tenderCategories.find(c => c.id === id)
        if (original && original.name !== this.editModal.name.trim()) {
          const res = await fetch(`${this.urlServer}/tender-category/${id}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
            body: JSON.stringify({ name: this.editModal.name.trim() }),
          })
          const data = await res.json()
          if (!res.ok || !data.status) {
            Swal.fire({ icon: 'error', title: 'Rename failed', text: data.message || 'Could not rename category.' })
            return
          }
        }

        // 2. Set department assignments
        const res2 = await fetch(`${this.urlServer}/tender-category/${id}/departments`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
          body: JSON.stringify({ departmentIds: this.editModal.selectedDepartmentIds }),
        })
        const data2 = await res2.json()
        if (!res2.ok || !data2.status) {
          Swal.fire({ icon: 'error', title: 'Save failed', text: data2.message || 'Could not save department links.' })
          return
        }

        await this.fetchTenderCategories()
        this.closeEditModal()
        Swal.fire({ icon: 'success', title: 'Saved', text: 'Category updated successfully.', timer: 1500, showConfirmButton: false })
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error', text: err.message })
      } finally {
        this.isSavingEdit = false
      }
    },

    async fetchTenderCategories() {
      try {
        const [catRes, supRes] = await Promise.all([
          fetch(this.urlServer + '/tender-category', {
            headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
          }),
          fetch(this.urlServer + '/suppliers', {
            headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + this.token }
          })
        ]);
        
        const catData = await catRes.json();
        const supData = supRes.ok ? await supRes.json() : [];
        
        let categories = [];
        if(catData && Array.isArray(catData.data)) {
            categories = catData.data;
        } else if (Array.isArray(catData)) {
            categories = catData;
        }
        
        let suppliers = [];
        if (Array.isArray(supData)) {
            suppliers = supData;
        } else if (supData && Array.isArray(supData.data)) {
            suppliers = supData.data;
        }
        
        // Manually compute supplier counts per category since backend is not yet deployed with new schema
        const counts = {};
        suppliers.forEach(supp => {
            if (supp.SupplierTenderCategory && Array.isArray(supp.SupplierTenderCategory)) {
                supp.SupplierTenderCategory.forEach(sc => {
                    const catId = sc.tenderCategoryId || (sc.tenderCategory && sc.tenderCategory.id);
                    if (catId) {
                        counts[catId] = (counts[catId] || 0) + 1;
                    }
                });
            }
        });
        
        categories.forEach(cat => {
            if (!cat._count) {
                cat._count = { supplierTenderCategories: counts[cat.id] || 0 };
            } else {
                cat._count.supplierTenderCategories = counts[cat.id] || 0;
            }
        });
        
        this.tenderCategories = categories;
      } catch (err) {
        console.error('Error fetching Procurement Categories or suppliers:', err)
      } finally {
        setTimeout(() => {
          if (this.dataTable) {
            try { this.dataTable.destroy() } catch (e) { console.warn('Error destroying datatable', e) }
            this.dataTable = null
          }
          if (this.initializeDataTable) this.initializeDataTable()
        }, 50)
      }
    },
    async postTenderCategories() {
      if(!this.tenderCategory.trim()) {
          Swal.fire({ icon: 'warning', title: 'Input Required', text: 'Please enter a tender category name.' });
          return;
      }
      this.isPosting = true;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + this.token },
        body: JSON.stringify({ name: this.tenderCategory })
      };
      
      try {
          const res = await fetch(this.urlServer + '/tender-category', requestOptions)
          const data = await res.json()
          
          if(data.status === true || (data.data && data.data.id)) {
            this.tenderCategory = "";
            await this.fetchTenderCategories();
            Swal.fire({
                icon: 'success',
                title: 'Tender Category created successfully',
                showConfirmButton: false,
                timer: 1500
            })
          } else {
            Swal.fire({
                icon: 'error',
                title: 'Failed to create',
                text: data.message || 'Error occurred'
            })
          }
      } catch(err) {
          Swal.fire({
              icon: 'error',
              title: 'Failed to create',
              text: err.message
          })
      } finally {
          this.isPosting = false;
      }
    },
    async deleteTenderCategory(id) {
      if(!confirm("Are you sure you want to delete this tender category?")) return;
      
      const requestOptions = {
        method: "DELETE",
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.token
        }
      };
      
      try {
          const res = await fetch(this.urlServer + '/tender-category/' + id, requestOptions)
          const data = await res.json()
          
          if(data.status === true || res.ok) {
            await this.fetchTenderCategories();
            Swal.fire({
                icon: 'success',
                title: 'Tender Category deleted',
                showConfirmButton: false,
                timer: 1500
            })
          } else {
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete',
                text: data.message || 'Error occurred'
            })
          }
      } catch (err) {
          Swal.fire({
              icon: 'error',
              title: 'Failed to delete',
              text: err.message
          })
      }
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    initializeDataTable() {
      try {
        const table = this.$el.querySelector('#tenderCategoriesTable')
        if (!table) return
        if (this.dataTable) { this.dataTable.destroy(); this.dataTable = null }
        this.dataTable = $(table).DataTable({
          dom: 'Bfrtip',
          responsive: true,
          language: {
            paginate: {
              previous: '<i class="fas fa-chevron-left"></i>',
              next: '<i class="fas fa-chevron-right"></i>',
            },
          },
          buttons: [
            'colvis',
            'pageLength',
            { extend: 'csv', text: 'Export CSV', className: 'btn btn-primary btn-sm' },
            { extend: 'excel', text: 'Export Excel', className: 'btn btn-primary btn-sm' },
            { extend: 'print', text: 'Print', className: 'btn btn-secondary btn-sm' },
          ],
        })
      } catch (err) {
        console.warn('DataTable init failed', err)
      }
    }
  }
}
</script>

<style scoped>
.panel {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* Custom DataTable button styling */
:deep(.dt-buttons) {
  margin-bottom: 1rem;
}

:deep(.dt-button) {
  background-color: #f8f9fa !important;
  color: #495057 !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 6px 11px !important;
  font-size: 11px !important;
  font-weight: 500 !important;
}

:deep(.dt-button:hover) {
  background-color: #e9ecef !important;
  color: #495057 !important;
}

:deep(.dt-button:first-child) {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

:deep(.dt-button:last-child) {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

:deep(.dt-button:not(:first-child)) {
  border-left: 0 !important;
}

/* Edit modal */
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-box {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.modal-header-custom {
  padding: 14px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal-body-custom {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}
.modal-footer-custom {
  padding: 12px 20px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.dept-checklist {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
}

.dept-checklist .form-check {
  padding: 8px 0 8px 2rem;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  border-radius: 3px;
}

.dept-checklist .form-check:hover {
  background-color: #f8f9fa;
}

.dept-checklist .form-check-input {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.5rem;
  cursor: pointer;
  border: 1.5px solid #dee2e6;
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.dept-checklist .form-check-input:hover {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.1);
}

.dept-checklist .form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.dept-checklist .form-check-label {
  margin-bottom: 0;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  color: #495057;
}

.dept-checklist .form-check-label:hover {
  color: #0d6efd;
}
</style>
